export default __webpack_public_path__ + "static/media/minus-gray.261275d4.svg";